module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lxm-share"
  }, [_c('div', {
    staticClass: "page"
  }, [_c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("您的" + _vm._s(_vm.state.type) + "链接是")]), _vm._v(" "), _c('lxm-row', {
    staticClass: "lxm-share__row",
    attrs: {
      "name": _vm.state.link,
      "href": _vm.state.link
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("您还可以长按保存二维码，转发到朋友圈")]), _vm._v(" "), _c('div', {
    staticClass: "lxm-share__qrcode-container box"
  }, [_c('div', {
    staticClass: "lxm-share__qrcode-title"
  }, [_vm._v(_vm._s(_vm.state.name))]), _vm._v(" "), _c('img', {
    staticClass: "lxm-share__qrcode",
    attrs: {
      "src": _vm.state.qrcodeSrc
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "lxm-share__qrcode-by"
  }, [_vm._v("By " + _vm._s(_vm.state.by))])])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5360ddaa", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5360ddaa!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/Share.vue
// module id = 852
// module chunks = 0